import Instance from "../../../../Axios";

// New Actions for the app

const GetCredEstadosFormacoes = () => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/estadosFormacoes`)
    .then(({ data }) => {
      dispatch({
        type: "GET_CRED_ESTADOS_FORMACOES",
        payload: data.yData,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetCredEstadosFormacoes;